/**
 * Goal-Setting Meeting booking config. Booking is always in-app: pick a time,
 * pay, then sign. Length and paths come from offerCatalog.json.
 */
import offerCatalog from './offerCatalog.json';

export const BOOKING_PATH = offerCatalog.paths.booking;
export const BOOKING_CONFIRMED_PATH = `${BOOKING_PATH}/confirmed`;
export const MEETING_DURATION_MINUTES = offerCatalog.goalSettingMeeting.durationMinutes;

/** Analytics booking_type for the paid meeting. */
export const MEETING_BOOKING_TYPE = 'goal_setting_meeting_paid';

/** Same-origin booking path with optional attribution params (SPA navigation). */
export function getMeetingBookingHref(searchParams = {}) {
  const params = new URLSearchParams();
  Object.entries(searchParams || {}).forEach(([key, value]) => {
    if (value) params.set(key, String(value));
  });
  const query = params.toString();
  return query ? `${BOOKING_PATH}?${query}` : BOOKING_PATH;
}

const PENDING_HOLD_KEY = 'bpa_pending_meeting_hold';

/** The calendar hold being paid for, kept across the Stripe redirect so a cancelled checkout can release it. */
export function savePendingHold(hold) {
  try {
    window.sessionStorage.setItem(PENDING_HOLD_KEY, JSON.stringify(hold));
  } catch (_error) {
    // Storage unavailable: the hold still expires on its own.
  }
}

export function readPendingHold() {
  try {
    return JSON.parse(window.sessionStorage.getItem(PENDING_HOLD_KEY) || 'null');
  } catch (_error) {
    return null;
  }
}

export function clearPendingHold() {
  try {
    window.sessionStorage.removeItem(PENDING_HOLD_KEY);
  } catch (_error) {
    // ignore
  }
}

const booking = {
  BOOKING_PATH,
  BOOKING_CONFIRMED_PATH,
  MEETING_DURATION_MINUTES,
  MEETING_BOOKING_TYPE,
  getMeetingBookingHref,
  savePendingHold,
  readPendingHold,
  clearPendingHold,
};

export default booking;
